import * as React from 'react';
import { useCallback } from 'react';
import DatePicker from 'react-datepicker';
import * as moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import type { CustomDatepickerProps } from './types';

const CustomDatepicker: React.FC<CustomDatepickerProps> = ( {
    selected,
    startDate,
    endDate,
    minDate,
    maxDate,
    onChange,
    locale = 'de',
    ...restProps
} ) => {
    const handleChange = useCallback( ( date: Date ) => {
        if ( date ) {
            onChange( moment( date ) );
        }
    }, [ onChange ] );

    const renderCustomHeader = useCallback( ( { date }: { date: Date } ) => {
        const selMonth = moment( date ).locale( locale ).format( 'MMMM' ).toUpperCase();
        const selYear = moment( date ).locale( locale ).format( 'YYYY' );

        return (
            <div className='react-datepicker__current-month'>
                <div className='currentMonth'>
                    {selMonth}
                </div>
                <div className='currentYear'>
                    {' / ' + selYear}
                </div>
            </div>
        );
    }, [ locale ] );

    const formatWeekDay = useCallback( ( nameOfDay: string ) => {
        moment.locale( locale );
        const weekdaysMin = moment.localeData().weekdaysMin();

        const englishWeekdays = [ 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday' ];
        const dayIndex = englishWeekdays.indexOf( nameOfDay );

        if ( dayIndex !== -1 ) {
            return weekdaysMin[dayIndex];
        }

        return nameOfDay;
    }, [ locale ] );

    return (
        <DatePicker
            { ...restProps }
            selected={ selected ? selected.toDate() : undefined }
            startDate={ startDate.toDate() }
            endDate={ endDate.toDate() }
            minDate={ minDate ? minDate.toDate() : undefined }
            maxDate={ maxDate ? maxDate.toDate() : undefined }
            onChange={ handleChange }
            renderCustomHeader={ renderCustomHeader }
            formatWeekDay={ formatWeekDay }
        />
    );
};

export { CustomDatepicker };
